<template>
	<div class="functional-structure">
		<div class="functional-structure-box">
			<div
				class="tag-box"
				v-for="(item, index) in tabList"
				:key="index"
				@click="onTab(index)"
				@mouseover="onChangeBanner(index)"
			>
				<div
					class="tag"
					:class="[currentTab == index ? 'active' : '']"
				>
					<span class="title">
						{{ item.title }}
					</span>
				</div>
			</div>
		</div>
		<div class="block-box">
			<div
				class="block"
				v-for="(item, index) in tabList"
				:key="index"
			>
				<div
					class="img"
					:class="{
						move: currentTab === 1,
						back: currentTab === 0
					}"
				>
					<img
						:src="item.image"
						alt
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FunctionalStructure',
	components: {},
	props: {},
	data() {
		return {
			// 当前tab下标
			currentTab: 0, 
			// 当前点击图片
			activeImage: 'https://static.bimcc.com/openim/16644232839394517B5F883D89DBBB28F635695769CD6.png',
			tabList: [
				{
					id: 0,
					title: '解决方案蓝图',
					image: 'https://static.bimcc.com/openim/1664423349545415B20BAC8BD29B57BEB1477FE83E494.png'
				},
				{
					id: 1,
					title: '智慧建造平台架构图',
					image: 'https://static.bimcc.com/openim/1666660261002C1E962FBFBE30E23E618830EBE239E1C.png'
				}
			]
		};
	},
	methods: {
		/**
		 * @desc: 切换图片
		 */
		onTab(index) {
			this.currentTab = index;
			this.activeImage = this.tabList[this.currentTab].image;
		},
		/**
		 * @desc: 切换轮播
		 */
		onChangeBanner(index) {
			this.currentTab = index;
			this.activeImage = this.tabList[index].image;
		}
	}
};
</script>

<style lang="less" scoped>
.move {
	transform: translate(-100%, 0px);
	transition: transform 0.5s;
}
.back {
	transform: translate(0px, 0px);
	transition: transform 0.5s;
}
.active {
	color: #131314;
	font-weight: 500;
	font-weight: bold;
	&:before {
		display: block;
		position: absolute;
		top: 60px;
		width: 120%;
		height: 2px;
		margin: 0 auto;
		background-color: #3370ff;
		content: '';
		border-radius: 1px;
		animation: myfirst 0.6s;
		-webkit-animation: myfirst 0.6s;
		animation-fill-mode: forwards;
		-webkit-animation-fill-mode: forwards;
	}
	@keyframes myfirst {
		0% {
			width: 0%;
		}
		100% {
			width: 120%;
			height: 2px;
		}
	}
	@-webkit-keyframes myfirst /* Safari and Chrome */ {
		0% {
			width: 0%;
		}
		100% {
			width: 120%;
			height: 2px;
		}
	}
}
.functional-structure {
	position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
	width: 56.5%;
	.functional-structure-box {
    cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		border-bottom: 1px solid rgba(187, 190, 202, 0.5);
		.tag-box {
			padding: 40px;
			box-sizing: border-box;
			.tag {
				display: flex;
				justify-content: center;
				align-items: center;
				position: relative;
				width: 200px;
				height: 20px;
				.title {
					color: #131314;
					font-size: 20px;
					font-family: 'albb';
				}
			}
		}
	}
	.block-box {
		display: flex;
		justify-content: flex-start;
		align-items: center;
    width: 40vw;
		overflow: hidden;
		.block {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			.img {
				width: 100vw;
				padding-top: 20px;
				box-sizing: border-box;
				img {
					width: 100%;
				}
			}
		}
	}
}
</style>
